import { render, staticRenderFns } from "./number-component.vue?vue&type=template&id=f1eac7a6&scoped=true&"
import script from "./number-component.vue?vue&type=script&lang=js&"
export * from "./number-component.vue?vue&type=script&lang=js&"
import style0 from "./number-component.vue?vue&type=style&index=0&id=f1eac7a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1eac7a6",
  null
  
)

export default component.exports